import React from 'react';
import PropTypes from 'prop-types';

import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';

import { Card, CardText, CardTitle } from 'react-md';

class DocumentsCard extends React.PureComponent {
  render() {
    const { data, handleRoute } = this.props;

    return data.map(({ name, url }, idx) => (
      // eslint-disable-next-line react/no-array-index-key
      <Card className="document" key={idx}>
        <div onClick={() => handleRoute({ url })} onKeyPress={() => handleRoute({ url })} role="link" tabIndex={0}>
          <CardTitle title={name} />
          <CardText>
            <div className="pdf-icon">
              <PictureAsPdfIcon />
            </div>
          </CardText>
        </div>
      </Card>
    ));
  }
}
DocumentsCard.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
    })
  ).isRequired,
  handleRoute: PropTypes.func.isRequired,
};

DocumentsCard.defaultProps = {};

export default DocumentsCard;
